import axios from "./axios";

export const listVersions = async () => {
  try {
    const data = await axios.get("/api/v1/provision/aiops");
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getVersion = async (sprint) => {
  try {
    const data = await axios.get(`/api/v1/provision/aiops/${sprint}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const createVersion = async (data) => {
  try {
    const response = await axios.put("/api/v1/provision/aiops", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateVersion = async (sprint, data) => {
  try {
    const response = await axios.post(`/api/v1/provision/aiops/${sprint}?op=update`, data,{
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return { status: "error", error };
  }
};

export const deleteVersion = async (sprint) => {
  try {
    const response = await axios.delete(`/api/v1/provision/aiops/${sprint}`);
    return response;
  } catch (error) {
    return { status: "error", error };
  }
};
export const exportVersion = async (sprint) => {
  try {
    const response = await axios.get(`/api/v1/provision/aiops/${sprint}?op=export`, {responseType: 'blob'});
    return response;
  } catch (error) {
    return { status: "error", error };
  }
};

export const importVersion = async (data) => {
  try {
    const response = await axios.post(`/api/v1/provision/aiops?op=import`, data,{
      headers: {
        "Content-Type": "multipart/form-data"
      },
    });
    return response;
  } catch (error) {
    return { status: "error", error };
  }
};